(() => {
  const root = document.documentElement;
  const one = (selector, scope = document) => scope.querySelector(selector);
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const setOpen = (element, open) => {
    if (!element) return;
    element.dataset.open = String(open);
    element.setAttribute('aria-hidden', String(!open));
  };

  function closeMenus(except = null) {
    all('[data-cm-nav-item][data-open=true]').forEach((item) => {
      if (item === except) return;
      item.dataset.open = 'false';
      one('[data-cm-nav-control]', item)?.setAttribute('aria-expanded', 'false');
    });
  }

  all('[data-cm-nav-item]').forEach((item) => {
    const control = one('[data-cm-nav-control]', item);
    const panel = one('[data-cm-nav-panel]', item);
    if (!control || !panel) return;
    const open = () => {
      closeMenus(item);
      item.dataset.open = 'true';
      control.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.dataset.open = 'false';
      control.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    control.addEventListener('click', () => item.dataset.open !== 'true' ? open() : close());
    control.addEventListener('keydown', (event) => {
      if (['ArrowDown', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        open();
        one('a', panel)?.focus();
      }
      if (event.key === 'Escape') close();
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenus();
    closeDrawer('mobile');
    closeDrawer('cart');
    const market = one('[data-cm-market-popover]');
    setOpen(market, false);
    one('[data-cm-market-toggle]')?.setAttribute('aria-expanded', 'false');
  });

  const backdrop = one('[data-cm-backdrop]');
  const drawers = {
    mobile: one('[data-cm-mobile-drawer]'),
    cart: one('[data-cm-cart-feedback]'),
  };
  function openDrawer(name) {
    const drawer = drawers[name];
    if (!drawer) return;
    Object.entries(drawers).forEach(([key, candidate]) => setOpen(candidate, key === name));
    setOpen(backdrop, true);
    root.style.overflow = 'hidden';
    drawer.querySelector('button, a, input')?.focus();
  }
  function closeDrawer(name) {
    setOpen(drawers[name], false);
    if (!Object.values(drawers).some((drawer) => drawer?.dataset.open === 'true')) {
      setOpen(backdrop, false);
      root.style.overflow = '';
    }
  }
  all('[data-cm-mobile-open]').forEach((button) => button.addEventListener('click', () => openDrawer('mobile')));
  all('[data-cm-mobile-close]').forEach((button) => button.addEventListener('click', () => closeDrawer('mobile')));
  all('[data-cm-cart-close]').forEach((button) => button.addEventListener('click', () => closeDrawer('cart')));
  backdrop?.addEventListener('click', () => { closeDrawer('mobile'); closeDrawer('cart'); });

  const marketToggle = one('[data-cm-market-toggle]');
  const marketPopover = one('[data-cm-market-popover]');
  marketToggle?.addEventListener('click', () => {
    const open = marketPopover?.dataset.open !== 'true';
    setOpen(marketPopover, open);
    marketToggle.setAttribute('aria-expanded', String(open));
  });

  all('[data-cm-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
    const main = one('[data-cm-gallery-main]');
    if (!main) return;
    main.src = button.dataset.src;
    main.alt = button.dataset.alt || '';
    all('[data-cm-gallery-thumb]').forEach((candidate) => candidate.setAttribute('aria-current', String(candidate === button)));
  }));

  function productVariants(scope) {
    const data = one('[data-cm-product-json]', scope);
    if (!data) return [];
    try { return JSON.parse(data.textContent); } catch { return []; }
  }

  function selectedOptions(scope) {
    return all('[data-cm-option] fieldset', scope).map((fieldset) => one('input:checked', fieldset)?.value).filter(Boolean);
  }

  function money(cents) {
    const currency = document.documentElement.dataset.currency || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  }

  all('[data-cm-product-form]').forEach((form) => {
    const scope = form.closest('[data-cm-pdp]') || form;
    form.addEventListener('change', () => {
      const variants = productVariants(scope);
      const options = selectedOptions(scope);
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) return;
      one('[name=id]', form).value = variant.id;
      const price = one('[data-cm-product-price]', scope);
      const compare = one('[data-cm-product-compare]', scope);
      const sku = one('[data-cm-product-sku]', scope);
      const button = one('[type=submit]', form);
      if (price) price.textContent = money(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : ''; compare.hidden = !variant.compare_at_price; }
      if (sku) sku.textContent = variant.sku || '';
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      const mediaId = variant.featured_media?.id;
      if (mediaId) one(`[data-media-id="${mediaId}"]`, scope)?.click();
    });
  });

  async function updateCartCount() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    all('[data-cm-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
    return cart;
  }

  all('[data-cm-ajax-cart]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = one('[type=submit]', form);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || 'Unable to add this item.');
      await updateCartCount();
      const title = one('[data-cm-cart-feedback-title]');
      const variant = one('[data-cm-cart-feedback-variant]');
      const image = one('[data-cm-cart-feedback-image]');
      if (title) title.textContent = item.product_title || item.title;
      if (variant) variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      if (image) { image.src = item.image || ''; image.alt = item.product_title || item.title; image.hidden = !item.image; }
      openDrawer('cart');
    } catch (error) {
      const message = one('[data-cm-cart-error]', form);
      if (message) { message.hidden = false; message.textContent = error.message; }
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  }));

  all('[data-cm-quantity]').forEach((control) => {
    const input = one('input', control);
    all('button', control).forEach((button) => button.addEventListener('click', () => {
      const delta = Number(button.dataset.delta || 0);
      input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  const cartForm = one('[data-cm-cart-form]');
  if (cartForm) {
    let timer;
    cartForm.addEventListener('change', (event) => {
      if (!event.target.matches('[name^="updates"]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => cartForm.submit(), 250);
    });
  }

  const styleTarget = one('[data-cm-style-siblings]');
  if (styleTarget && globalThis.CRAFTSMAN_STYLE_MAP) {
    const handle = styleTarget.dataset.productHandle;
    const siblings = globalThis.CRAFTSMAN_STYLE_MAP[handle] || [];
    if (siblings.length > 1) {
      styleTarget.hidden = false;
      styleTarget.innerHTML = `<strong>Color</strong><div class="sf-cm-style-links">${siblings.map((item) =>
        `<a href="/products/${encodeURIComponent(item.handle)}" aria-current="${item.handle === handle}">${item.color}</a>`).join('')}</div>`;
    }
  }
})();
